/*
 * @Author: lsqbeyond lsqbeyond@yeah.net
 * @Date: 2025-10-06 13:19:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-04-22 11:26:05
 * @FilePath: \tracenew\src\i18n\locales\zh.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  closestr:'关闭',
  xqnews:{
    
     xqnews01:'合作院校—同济大学',
     xqnews02:'成果展示',
     xqnews03:'同济大学（Tongji University）是位于中国上海市的一所综合性全国重点大学，是原“985工程”、原“211工程”重点建设大学。今年，我司与同 济大学德语系建立了',
     xqnews04:'产教融合研究生联合培养基地。',
     xqnews05:'2022年7月，同济大学德语MTI学生于我司进行了为期4周的线上实习。临近实习尾声，全体实习同学于7月29日上午对本次实习进行了汇报总结。会上同学们分享了在我司的实习收获。对此，我司领导也给出了他的见解与点评，加深了同学们对本次实习意义的理解。同济大学德语系系主任伍慧萍老师对本次实习安排给予了高度的肯定。',
     xqnews06:'合作院校—兰州理工大学',
     xqnews07:'成果展示',
     xqnews08:'兰州理工大学（Lanzhou University of Technology），位于甘肃省兰州市，是甘肃省人民政府、中华人民共和国教育部、国家国防科技工业局共建的甘肃省高水平大学。',
     xqnews09:'2024年4月11日，之于行与兰州理工大学外语学院各领导、老师围绕社会需求、外语人才培养、科研合作、实习就业等相关事宜进行了深 入交流并签署了',
     xqnews010:'就业实习基地协议。',
     xqnews011:'本次签约进一步深化了校企合作交流，在促进产教深度融合、拓宽毕业生就业渠道、提升人才培养质量等方面发挥了积极的推动作用。',
    xqnews012:'合作院校—四川外国语大学',
     xqnews013:'成果展示',
     xqnews014:'四川外国语大学（Sichuan International Studies University）位于中国直辖市重庆市， 是国家最早设立的四所外语专业高等院校之一。我公司在多年前就成为了四川外国语大学德语学院的 ',
     xqnews015:'翻译实习基地',
     xqnews016:'，会不定期为同学们提供翻译实践机会。',
     xqnews017:'为进一步增强德语学院学生对企业的了解和认识、扩宽师生视野，2022年7月5日上午由德语学院余传玲老师带领德语学院本科学生对我司进行了走访，并参与了公司举办的翻译实践分享会。分享会中，公司翻译部同事为川外同学们介绍了翻译部门的工作内容、工作流程、翻译使用工具等。分享会后，同事们和同学们一起交流有关学习、实习、面试和工作等方面的方法及经验。',
     xqnews018:'四川外国语大学翻译实习基地',
     xqnews019:'四川外国语大学授课',
     xqnews020:'四川外国语大学德语学院与我公司进行校企合作以来，开展了全面多样的合作内容。',
     xqnews021:'我公司创始人何志欣先生也定期地为四川外国语大学的德语学子授课或举行讲座。授课主题包括:实习分享会、技术文献翻译要点与实操、专利翻译介绍、专利翻译技巧浅析与实践探讨等。以上授课内容涵盖之于行翻译工作所涉及的主要领域，即本地化翻译和专利文献翻译',
         xqnews021a:'',
      xqnews021b:'',
      xqnews021c:'',
      xqnews021d:'',
       xqnews021f:' ',
     xqnews022:'通过实习实训与专家授课等合作内容，同学们可以了解到丰富的翻译理论知识，包括翻译软件操作、翻译工作流程、翻译规范标准等等。同时，结合这些理论知识，他们进行翻译实践，接触实际的翻译文本，遇到多种翻译问题，并在解决问题的过程中积累不同的翻译技巧。',
     xqnews023:'',
     xqnews024:'',
     xqnews025:'',

    
  },
  hknews:{
    hknews01:'回馈社会',
    hknews02:'四川外国语大学',
    hknews03:'启文奖学金捐赠及发放',
    hknews04:'2020年10月24日，恰逢四川外国语大学德语专业成立60周年庆典活动之际，我公司创始人何志欣先生为支持学校教育事业，为川外的德语学子设立了',  
    hknews0411:'',  
    hknews05:'"启文奖学金"',
    hknews06:'，借此鼓励莘莘学子，任何优秀都是不断训练的结果，我们需要坚持不懈才能有所成就。何志欣先生强调了语言与翻译工作应当与时俱进，语言与科学之间也存在着紧密的联系；同时他相信，人工翻译永远不会被机器翻译所取代。',
    hknews07:'"点亮智慧"助学工程',
    hknews08:'首都知识产权服务业协会',
    hknews081:'扶贫助学公益项目',
    hknews09:'自2018年起，首都知识产权服务业协会开启',
    hknews09111:'',
    hknews10:'"点亮智慧"扶贫助学工程',
    hknews11:'，有效促进贫困地区教育事业发展， 履行了知识产权服务行业的社会责任。之于行也积极响应号召，参与爱心事业。',
    hknews12:'上海教委本科教育教学评估',
    hknews13:'留学生创业导师',
    hknews14:'',
    hknews15:'',
  },
  hynews:{
    texthy01:'行业活动精彩回顾',
    hynews02:'2021年10月，《知识产权价值认识》，之于行创始合伙人何志欣先生在',
    hynews02111:'',
    hynews03:'《来安县技术交易大会》',
    hynews04:'担任评委和授课专师。',
    hynews05:'2023年3月，',
    hynews06:'《"一带一路"医学科技成果转化交流大会》',
    hynews07:'，之于行创始合伙人何志欣先生担任授课专家讲授《医学专利申请》，并参与了包括医企共建转化平台的模式探讨、版权等创新政策支持对成果转化的推动作用、医疗健康产业赛道中的医工转化聚集、医工交叉的人才培养等议题的内圆桌讨论。',
    hynews08:'更多精彩活动展示',
    hynews09:'2023年9月',
    hynews010:'之于行创始合伙人何志欣先生 受',
    hynews011:'中华护理学会',
    hynews012:'邀请，参加',
    hynews013:'《中华护理学会全国门诊护理学术交流会议》',
    hynews014:'并担任评委和授课专师。',
    hynews015:'2023年11月',
    hynews016:'《护理创新与转化》，之于行创始合伙人何志欣先生受',
     hynews016111:'',
    hynews017:'广东护理协会、岭南南丁格尔护理研究院',
    hynews018:'邀请，在',
    hynews019:'《广东省护理学会创新大赛》',
    hynews020:'担任评委和授课专师。',
    hynews021:'专业培训与学术交流',   
    hynews022:'《医疗创新点挖掘》',
    hynews023:'宣武医院2018年至2023年期间多次，培训对象：全院护士长',
    hynews024:'《高价值专利培育》',
    hynews025:'北京住总集团有限责任公司，2018年至2024年期间多次，培训对象：项目部全体工程技术人员',
    hynews026:'《探究发明与专利》',
    hynews027:'同济大学电子信息学院2021年至2022年期间多次，培训对象：研究生及部分老师、教授；得到好评',
    hynews028:'《中国专利体系介绍》',
    hynews029:'无锡国际生物论坛，全程英文发言，与会听众包括Springer编辑、自然科学杂志编辑等，受到美、意、德多国专家好评，特别收到美国及中科院双院院士时玉舫的好评',
    hynews030:'《无形资产价值认识》',
    hynews031:'中国海归创业大赛2018～2021年，培训对象：海归创业人员，其中涉及生物的内容得到了俄罗斯科学院院士肖桂山等知名教授专家好评',
    hynews032:'《高价值专利认识》',
    hynews033:'佛山创新大讲堂2021～2022年多次，培训对象：佛山各类企业；得到医疗器械厂家的广泛好评',
    hynews034:'《专利与工业文化》',
    hynews035:'德国工业文化研究2022年6月，与会代表包括北外副校长在内的大量专家',
    hynews036:'2024年中国中医药科技发展中心主办的“中药院内制剂开发及新药转化培训班”授课',
    hynews037:'2024年CSCO大会发言并接受现场采访',
    hynews038:'2024年中华医学会第三次免疫皮肤病诊治工程技术学术会议',
    hynews039:'2024年发起成立“北京围手术期医学学会科技创新与成果转化专委会”',
    hynews040:'2025年海归创业大赛导师',
    hynews041:'2025年第十九届国际光动力大会（IPA 2025）',
    hynews042:'各大会议论坛交流现场照片',
    hynews043:'专利实操技能培训案例',
    hynews044:'自 2021年7月 之于行首次承办',
    hynews045:'《电力行业科技创新及专利实操技能培训班》',
    hynews046:'后， 之于行知识产权创始人 何志欣先生、吕晓蓉博士 反复多次受邀担任授课专家，为 中国电力技术市场协会全体会员全面系统地讲授科技创新和专利实操技能，合 计受训人数超过千人。',
    hynews047:'2021年7月起',
    hynews048:'2021年7月起',
    hynews049:'中国电力技术市场协会',
    hynews050:'',
    hynews051:'',
    hynews052:'',
    hynews053:'',
    hynews054:'',
    hynews055:'',
  },
  wklang:'工作语言 : ',
  tdeyu:{
          name1: '宝马公司'  , 
         name2: '曼集团'  ,
         name3: '万通公司'  ,
         name4: '西克集团'  ,
         name5: '通快集团'  , 
         name6: 'WANZL 旺众'  ,
          name7: 'GWK'  ,
          name8: '博世'  ,
          name9: '梅施汽车服务'  ,
          name10: 'Festo' ,
          name11: '佛克公司'   ,
         name12: 'FAM集团' 
  },
    tyingyu:{
          name1: '谷歌公司'  , 
         name2: '费森尤斯医疗'  ,
         name3: '德国普旭公司'  ,
         name4: '隐适美'  ,
         name5: '宾利汽车公司'  , 
         name6: 'LAPP缆普集团'  ,
          name7: '哈伯斯特'  ,
          name8: 'Moleskine'  ,
          name9: '锋翔科技'  ,
          name10: 'DxO' ,
          name11: 'PrimaLoft'   ,
         name12: '简森集团' 
  },
  teamguding1:'Vielen Dank für die guten und zahlreichen Kommentare in diesem Job. Wir und der Kunde haben sich sehr gefreut!',
  teamguding2:'Danke an den Übersetzer und bitte weiter so machen in den zukünftigen Jobs.',
  teamguding3:'Unser Kunde Veridos war sehr zufrieden mit euerletzten Übersetzung.',
  teamserve01:'翻译团队概况',
  teamserve02:'年历史',
  teamserve03:'翻译团队已有',
  teamserve04:'10年历史',
  teamserve05:'全职人员',
  teamserve06:'现有全职人员',
  teamserve07:'11名',
  teamserve08:'成都、重庆和北京公司',
  teamserve09:'其中',
  teamserve10:'8位',
  teamserve11:'在成都、重庆和北京公司',
  teamserve12:'来自台湾和德国',
  teamserve13:'另外',
  teamserve14:'3位',
  teamserve15:'来自台湾和德国', 
  teamserve16:'团队由多名国内外名牌大学外语专业本科生和硕士研究生组成。',
  teamserve17:'主要负责各类技术文献和专利的翻译与校对',
  teamserve18:'涉及语种包括',
  teamserve19:'德语',
  teamserve20:'英语',
  teamserve21:'以及',
   teamserve22:'简体',
  teamserve23:'和',
  teamserve24:'繁体中文',
  teamserve25:'， 年平均翻译量不低于',
  teamserve26:'250多万字。',
  teamserve27:'专业优势与客户信任',
  teamserve28:'之于行翻译团队译员经验丰富，翻译质量稳定，深得客户信任，因此公司翻译业务量一直处于',
  teamserve29:'增长状态。',
  teamserve30:'专利、司法及技术文献翻译',
  teamserve31:'专利申请文件翻译',
  teamserve32:'专利合同翻译',  
  teamserve33:'审查意见通知书正文翻译',
  teamserve34:'其他手续文件翻译',
  teamserve35:'专利证书翻译',
  teamserve36:'专利授权文本核查',
  teamserve37:'PPH申请翻译',
  teamserve38:'欧洲授权专利权利要求书翻译',
  teamserve39:'侵权诉讼证据翻译',
  teamserve40:'法院判决书、调解书、行政决定书或者行政裁定书翻译',
  teamserve41:'无效证据翻译',
  teamserve42:'本地化流程',
  teamserve43:'使用说明书翻译',   
  teamserve44:'用户手册翻译',
  teamserve45:'操作手册翻译',
  teamserve46:'诊断调试翻译',
  teamserve47:'软件本地化翻译',
  teamserve48:'翻译语言',
  teamserve49:'德语翻译',
  teamserve50:'英语翻译',
  teamserve51:'我们的客户',
  teamserve52:'德语项目',
  teamserve53:'英语项目',
  teamserve54:'WIPOTEC合作案例——全球顶尖的智能称重和检测技术装备提供者',
  teamserve55:'WIPOTEC集团是全球顶尖的智能称重和检测技术装备提供者。我司与WIPOTEC公司于2019年开始合作，我司优秀的翻译团队，帮助客户处理',
  teamserve56:'高难度',
  teamserve57:'专利文本的中英及中德互译，我司专业的专利团队，协助客户优化专利方案，尽快获得授权；我司细致的流程团队，认真负责地监控专利申请全流程，为专利技术权保驾护航。',
  teamserve58:'在与WIPOTEC合作中，我司流程部发现两件专利申请人名称有所差异，但实地址完全相同。在较短维权压力下，为避免出现专利申请信息录入错误，通过向客户和德国律师事务所二次确认，在指出有区别的中文名称的同时，给出两种解决方案供客户选择，其中也包括完备的手续文件供签署。在较短时间内完成了包括各类变更手续等一系列相关工作，第一时间避免了后续权属纠纷。我司严谨规范的流程操作显示出日常高水平训练水准，也体现了国内一流事务所的作业水平，赢得了顶尖智能称重作业公司WIPOTEC的信任。',   
  teamserve59:'华中科技大学合作案例——国家重点高校专利申请服务',
  teamserve60:'华中科技大学入选国家',
  teamserve61:'985工程 、 211工程',
  teamserve62:'，是世界知名高水平大学，中国顶尖大学，自',
  teamserve63:'2017年',
  teamserve64:'与我司建立联系。 这五年来，我司共计代理了华中科技大学计算机学院近百件中国发明专利申请以及超过六十项美国发明专利申请。 在提供高水准、高授权率、高性价比服务的同时，也主动适应学校政策调整，还确保其中美专利授权率始终高达',
  teamserve65:'95%以上。',
  teamserve66:'通过我公司高质量翻译和专业化定制服务，不仅曾协助美国专利局在一年之内完成专利授权程序，而且还曾在美国官费调整、外所成本上涨的情况下，通过与外所协商将各项工作更进一步细化，通过合理分工配合，使得总体费用并不增反减。控制新申请成本项目的推动过程，不仅结果得益于美方事务所认可并信任我司认真负责的工作作风，更因为在之前与美方事务所的合作中，我方交付美方事务所的译文、修改文件及各项必要手续文件和信息在十年间从未出现偏差，因此通过这少不必要的美方质检环节，在保证高质量的同时，减少了不必要的成本。华中科技大学计算机学院因此对我司给予了高度评价。',
  teamserve67:'合作成果统计',
  teamserve68:'近100件',
  teamserve69:'中国发明专利申请',
  teamserve70:'60+项',
  teamserve71:'美国发明专利申请',
  teamserve72:'95%+',
  teamserve73:'中美专利授权率',
  teamserve74:'5年',
  teamserve75:'稳定合作关系',
  teamserve76:'翻译客户反馈——本地化翻译',
  teamserve77:'宝马公司',
  teamserve78:'（非常感谢您们在这个项目中提供的大量优秀注释，我们和客户都非常高兴！）',
  teamserve79:'（感谢您们的译员，请在今后的工作中继续保持。）',
  teamserve80:'某客户',
  teamserve81:'（我们的客户Veridos对上次的翻译非常满意。）',
  teamserve82:'某瑞士事务所',
  teamserve83:'我们非常欣赏之于行翻译团队',
  teamserve84:'同事们的工作态度以及存细认真的程度， 每次合作他们都会带给我一份额外的"惊喜"。由于我们的专利申请彼此不同，因此也有着不同的问题和要求，之于行翻译团队每次都会在 ',
  teamserve85:'提交专利申请翻译之前提供一份意见反馈，指出权利要求书、说明书或附图中的问题',
  teamserve86:'，例如技术特征不清楚、原文打字错误等。事实表明， 这些反馈意见',
  teamserve87:'大幅度降低后期的专利代理费',
  teamserve88:'。因此，未来我还会继续增加翻译委托任务，向其他朋友推荐他们。',
  teamserve89:'',
  teamserve90:'',
  teamserve91:'',
  teamserve92:'',
  teamserve93:'',
  teamserve94:'',
  teamserve95:'',
  teamserve96:'',
  teamserve97:'',
  teamserve98:'',
  teamserve99:'',
  teamserve100:'',
  nav: {
    overview: '之于行概览',
    companyIntro: '公司简介',
    team: '团队',
    services: '服务范围',
    expertise: '专业领域',
    news: '动态资讯',
    contact: '联系我们'
  },
  team: {
    core: '核心团队',
    patent: '专利团队',
    trademark: '商标团队',
    foreign: '涉外团队',
    translation: '翻译团队',
    process: '流程团队',
    textt01:'查看个人简历',
    textt02:'专业经验',
    textt03:'教育背景',
    textt04:'业务领域',
    banner: {
      title: '专业团队',
      subtitle: '我们拥有一支经验丰富的专业团队，致力于为客户提供最优质的知识产权服务'
    },
    credentials: {
      title: '公司资质与荣誉',
      item1: {
        title: '之于行入选全国第一批“专利代理机构精准服务保障名单”',
        year: '2025年',
        p1: '北京之于行知识产权代理有限公司凭借扎实的专业实力、优质的服务水平、良好的信用记录及严格的行业自律，成功入选全国第一批 “专利代理机构精准服务保障名单”。',
        p2: '据国家知识产权局官网数据显示，北京地区现有专利代理机构约1360家。在此次公布的全国首批入选名单中，北京地区共有256家机构入选。经统计，北京之于行知识产权代理有限公司成功入选首批名单，在北京地区所有专利代理机构中占比约18.8%。这一数据不仅体现了首批入选机构所具备的专业水准与权威认可，也充分反映了之于行在北京地区专利代理行业中的综合实力和竞争优势。'
      },
      certificate1: {
        title: '第一批专利代理机构精准服务保障名单'
      },
      agencyName: '北京之于行知识产权代理有限公司',
      item2: {
        title: '之于行入选“中华全国专利代理师协会推荐的首批诉讼代理人名单”',
        badge: '权威认证',
        p: '之于行入选中华全国专利代理师协会推荐的<span style="font-weight: bold;">首批诉讼代理人名单</span>。我 公司凭借深耕知识产权领域的深厚积淀，此次共有<span style="font-weight: bold;">5位专利代理师（韩岳、吕晓蓉、何志欣、侯越玲、陈鹏程）</span>成功入选诉讼代理人名单。公司拥有五名具备 “民事诉讼” 或 “行政诉讼” 代理资格的诉讼代理人，这一专业配置在行业内独具优势。'
      },
      certificate2: {
        title: '中华全国专利代理师协会推荐的首批诉讼代理人名单'
      },
      note: '注：未标注“*”的专利代理师可以参加专利民事和行政诉讼，标注“*”的仅可参加专利行政诉讼。'
    },
    table: {
      two: {
        code: '机构代码',
        agencyName: '代理机构名称'
      },
      five: {
        uname1: '韩',
        uname11: '岳',
        uname2: '吕晓蓉',
        uname3: '何志欣',
        uname4: '侯越玲',
        uname5: '陈鹏程',

        code: '机构代码',
        name: '姓名',
        license: '执业备案号',
        agencyName: '机构名称',
        mark: '标注'
      },
      six:{
        text1:"专业服务理念",
        text2:"从成立之日起，之于行始终贯彻'得之于心，践之于行'的理念，服务于创新，致力于为创新提供全方位的支持与服务。公司专注于高价值专利申请、产业链专利资产包培育、知识产权战略规划与咨询、海外专利申请布局策略以及专利确权与维权等核心业务领域。",
        text3:"组织架构优势",
        text4:"凭借完善的组织架构体系和高度定制化的内部管理软件，由十五年工作经验的专业流程人员负责数据管理和规则设定，我们能够高效、准确且安全地为申请人提供卓越的知识产权服务。",
      }
    }
    ,textn1:"在复杂知产诉讼场景中，团队的技术背景优势尤为凸显。具备技术背景的代理师能深度解构案件中的专业技术细节，精准锚定争议焦点， 相较于普通代理人更能从技术逻辑与法律规则的交叉维度制定诉讼策略，在专利无效宣告、侵权判定等复杂案件中占据先机。",
    textn2:'这种“法律 + 技术"的双轨服务模式',
    textn3:"，正成为之于行在知产代理领域构建专业护城河的核心竞争力。",
     textn4:"团队聘任情况及奖项荣誉",
     textn5:"专业聘任与荣誉认可",
     textn6:"一级认证（2位）",
     textn7:"二级认证（6位）",
     textn8:"面对强势异议方的商标争议解决之道——突破注册困境终获核准",
     textn9:"在商标申请过程中，某生物科技企业的核心商标遭遇强势跨国企业阻击，该跨国企业以其引证商标为基础提出异议，并在后续谈判中多次无理变更会谈时间、地点并反复提出彼此相异的限制性和解条件，试图迫使中国企业放弃其核心类别的商标申请。",
     textn10:"之于行团队在代理过程中坚持“攻防一体”的策略：一方面，持续提交异议答辩与复审材料，稳固客户的权利主张；另一方面，主动发起对引证商标的撤三与无效程序，最终成功撤销该跨国企业商标，并彻底清除了其权利基础。",
     textn11:"面对两轮和解博弈，我方团队始终守住客户核心利益底线，拒绝“以虚换实”的不利条件，坚持通过法律程序争取无附加限制的完整保护。",
     textn12:"最终，经过三年半的持续努力，国家知识产权局裁定客户商标予以核准注册。本案不仅帮助企业突破注册困境，更为应对强势异议方的商标争议提供了一套可借鉴的“破局之道”。",
     textn13:'为国际客户提供值得信赖的商标法律顾问服务',
     textn14:"之于行商标团队在代表外国申请人管理和保护其在中国的商标权方面拥有丰富经验。例如通过提供商标生命周期的全程支持服务，包括清查、申请、审查、异议、无效宣告、执法和组合管理，帮助国际品牌所有者高效、战略性地应对中国法律和监管环境。",
     zhuanye:{
      year17:"年",
       
      dl01c:"之于行创始合伙人",
      dl02c:"之于行合伙人",
      dl03c:"之于行总经理",
      dl04c:"之于行专利代理师",
      dl05c:"受聘为中国仲裁法学研究会知识产权专委会副主任",
      dl06c:"受聘为中国留学生创业园特聘知识产权专家、中国海归创业大赛知识产权导师",
      dl07c:"受聘为四川外国语大学德语学院校外硕士生导师",
      dl08c:"受聘为北京市专利代理师协会特聘知识产权维权保护专家",
      dl09c:"受聘为首都知识产权服务业协会特聘培训专家",
      dl10c:"受聘为中山大学科技园创业导师",
      dl11c:"受聘为同济大学外国语学院德语系校外导师",
      dl12c:"受聘为中国城市科学研究会地下空间专业委员会委员",
      dl13c:"受聘为北京软件和信息服务业协会专家",
      dl14c:"入选中国知产保护维权援助中心专家智库",
      dl15c:"受聘为北京围手术期医学学会科技创新与成果转化专委会副主委",
      dl16c:"受聘为北京围手术期医学学会科技创新与成果转化专委会委员",
      dname1:"何志欣先生",
      dname2:"吕晓蓉女士",
      dname3:"侯越玲女士",
      dname4:"陈鹏程先生",
      dname5:"黎垚圻先生",
     }
     ,textnb1:"之于行多位核心成员获中华商标协会商标人才库认证",
     textnb2:"中华商标协会商标人才库",
     textnb3:"是行业专业能力的重要标杆，",
     textnb4:"之于行多位核心成员",
     textnb5:"能够跻身其中，不仅充分展现了我们在商标领域的深厚专业积淀与实践能力 ，更传递出行业对之于行专业服务水平、技术实力及行业贡献的广泛认可，为我们后续拓展业务、提升服务质量注入更强动力。",
     
  },
  services: {
    patent: '专利服务',
    trademark: '商标及著作权',
    trade: '商业秘密',
    rights: '侵权维权'
  },
   textse01:'专利挖掘服务、专利申请服务、审查及复审服务',
    textse02:'商标、集成电路布图设计及著作权登记、商标申请服务、答辩及近似检索服务',
   textse03:'基于销售额的分级策、基于技术难度的分级策略',
   textse04:'侵权应对、被控侵权的应对',
   textse05:'保护范围分析、权利稳定性分析',
   textnew01:'智见要闻',
   textnew02:'行业活动',
     textnew03:'回馈社会',
   textnew04:'校企合作',
  overview: {
    fanyi01:'原文',
    fanyi02:'原译文',
    fanyi03:'建议译文',
     fanyi04:'小词酿大祸：专利翻译误区案例剖析',
     fanyi05:'错误分析（一）',
     fanyi06:'错误分析（二）',
     fanyi07:'•  → 原译文中，"comprising"被错误地翻译为"由……构成"，形成了封闭性限定，从而误认为技术方案中只包含明确指出的元素，而不包含任何其他元素。这意味着，如果第三方产品或方法中包含了权利要求中提到的所有元素，但还额外添加了任何其他元素，那么它就不算侵犯该专利。这导致保护范围被严重缩窄。',
     fanyi071:'',
     fanyi072:'',
     fanyi08:'•  → 校对译文中，"comprising"译为"含有"，表示所描述的范围是开放的，可以包含其他未明确指出的元素，只要包含技术方案中提到的所有元素即可。这意味着，即使第三方产品或方法中包含了技术方案中提到的所有元素，并且还额外添加了一些其他元素，只要它满足了技术方案中提到的所有部分，仍然可能被认为是侵犯了该专利。因此，保护范围更为宽泛。',
     fanyi081:'',
     fanyi082:'',
      fanyi083:'',
     fanyi09:'•  → 原译文中未将"or"译出，导致技术方案可能被错误地理解为：',
     fanyi10:'上述的扩散阻挡层优选',
     fanyi11:'由',
     fanyi12:'以下组分',
     fanyi13:'构成：',
     fanyi14:'-  →  AlB2，',
     fanyi15:'及',
     fanyi16:'-  →  AlWB2，',
     fanyi17:'-  →  AlB2和AlWB2，',
     fanyi18:'-  →  TM硼化物，其中，TM是选自以下组的一个或多个过渡金属：3d、4d和5d元素，该层还含有铝。',
     fanyi19:'•  → 校对译文明确了"或者"的含义，表明这种包含是择一的，而非并行的。',
     fanyi20:'',
      fanyi21:'',
     fanyi22:'',
     fanyi23:'',
     fanyi24:'',
     fanyi25:'',
    hero: {
      title: '让知识成为权利',
      subtitle: 'Empowering your knowledge'
    },
    textoa1:'我们的服务流程',
    textoa2:'从初步咨询到成功授权，我们全程为您保驾护航。',
    textoa3:'初步咨询',
    textoa4:'发明人团队初始交底',
    textoa5:'交底缺陷',
    textoa6:'技术交底材料',    textoa61:'完整度低：',    textoa62:'文本框架失调且技术细节全无；',
    textoa7:'手绘制图部件无标识、结构表达错误',  textoa71:'，还存在装配关系合理性问题；',
   textoa81:'技术方案', textoa82:'肯定', textoa83:'难以满足《专利法》', textoa84:'第22条第 3款的', textoa85:'创造性', textoa86:'要求。',
    textoa9:'之于行团队优化过程',
    textoa101:'之于行团队在正式撰写及制作申请文本阶段，依据大量专利代理经验，与发明人团队积极沟通该案的',    textoa102:'核心技术点',    textoa103:'及',    textoa104:'相关临床经验',    textoa105:'检索获取了大量相关专利信息， 并多次向医疗器械领域专家咨询意见，',
       textoa106:'反复论证该方案的合理性',    textoa107:'，并由之于行团队',    textoa108:'制图',       textoa109:'后再次结合发明人团队的临床经验，顺利整合出“一种导管固定装置及 系统”的技术方案，期间研讨了《专利法》等相关法律法规，对该案申请文本及附图进行',    textoa110:'全面优化。',
    textoc011:'该高质量专利于2024年01月15日向国家知识产权局提交发明专利申请，2024年02月20被公布，',textoc012:'同年04月09日成功获得发明专利授权（ 历时仅约2个月）',textoc013:'， 授权公告号为CN117563096B。', 
    textoc02:'成功授权',
     textoc03:'专利审定授权',
     textoc04:'方案分析',
     textoc05:'高价值专利评估案例',
     textoc06:'该高质量专利于2024年02月09日向国家知识产权局提交实用新型专利申请，2024年09月17日成功获得实用新型专利授权，授权公告号为CN221714375U。',
     textoc07:'在撰写过程中结合之于行团队的三维建模制图成品，与发明人团队反复论证，优化了大量机械结构细节，同时考虑了枪头与产品的比例关系，',
     textoc08:'完整绘制了产品运作时的过程场景， 增加关键结构的局部放大图或内部结构拆解图 ', 
     textoc09:'，使得技术方案符合《专利审查指南》关于充分公开的规范要求。',   
     
     dialog301:'初始交底的',
      dialog302:'技术问题不明确、技术方案描述不清晰',
      dialog303:'且',
     dialog304:'技术效果表达不准确；',
      dialog305:'说明书',
     dialog306:'附图缺少大量必要运转部件',
      dialog307:'，不具备将产品顺利运作的结构零部件；',
     dialog308:'本领域技术人员',
      dialog309:'无法通过该交底所记载的内容完成技术方案的内容；',




     dlmdia01: '知识产权保护与跨境技术转让—Q3医疗器械有限公司', 
     dlmdia02: '核心商标服务：',
     dlmdia03: '在"阿基米德"中文商标申请被驳回后，根据之于行商标代理与Q3爱尔兰及其美国律师的反复商讨，最终Q3公司听取了之于行的商标建议，采取了替代英文商标',
     dlmdia04: '"Archimedes Stent"',
     dlmdia05: '。该新商标不仅顺利获权，而且由于其朗朗上口的品名，顺利在医用支架领域为客户所熟知。',
       dlmdia06: '核心专利服务：', 
     dlmdia07: '在实质审查期间，支架核心技术专利',
     dlmdia08: '被驳回',
     dlmdia09: '，但之于行复审无效团队在极其困难的情况下，独立面对挑战，通过与审查和复审部门的反复多次沟通，',
     dlmdia10: '最终在复审程序中纠正了审查部门的偏见，并顺利获批发明专利证书。',
     dlmdia11:'该专利目前已经成功转让给一家中国企业。 ',
      dlmdia12:'',
       dlmdia13:'之于行将继续协助处理与入境技术转让相关的法律及监管事宜，为跨境技术交易提供持续的专业支持。',
    addias01:'以商标抗外观设计-- 代表德国',
    addias02:'阿迪达斯(Adidas)',
    addias03:'外观专利无效案全胜',
    addias04:'在国家知识产权局第6W126279号无效宣告请求案中，',
    addias05:'之于行代理阿迪达斯有限公司',
    addias06:'，对李时宝持有的 "鞋 (6)" 外观设计专利（专利号：202230380010.8）提出无效宣告请求。代理团队由创始合伙人何志欣领衔，通过比对涉案专利与在先商标的视觉近似性，论证其易导致公众混淆，',
    addias07:'最终促使国家知识产权局作出专利权全部无效的决定。',
    addias08:'该案中，团队对《专利法》第 23 条第 3 款的精准适用，及对外观设计视觉效果的专业分析，成为胜诉关键。',
    addias0401:'',
    addias0402:'',
    apple01:'以技术为基石的胜诉之道---',
      apple02:'美国苹果(Apple Pay)',
      apple03:'专利侵权及无效程序',
      apple04:'在（2022）京 73 行初 3233 号发明专利权无效行政纠纷中，',
      apple05:'之于行代理第三人参与诉讼， 围绕苹果电脑贸易（上海）有限公司与国家知识产权局的专利权争议展开法律论证。',
      apple06:'尽管案件涉及复杂技术比对与行政程序审查 ，团队凭借技术背景代理人对专利技术方案的深度解读，在庭审中有效维护当事人权益，展现了在行政诉讼领域的专业应对能力。',
      apple061:'',
      apple07:'',
      Oerlikon01:'Oerlikon',
      Oerlikon02:'集团是全球著名的高科技公司，致力于机器设备和系统工程，有着',
      Oerlikon03:'100年',
      Oerlikon04:'的历史，拥有19000多名员工，在全球 35个国家拥有',
      Oerlikon05:'170',  
      Oerlikon06:'个分支机构。 ',
      Oerlikon07:'Oerlikon',
      Oerlikon08:'代表着领先的工业解决方案、纺织生产的顶级技术、薄膜涂层、传动系统、精密和真空技术。',
      Oerlikon09:'欧瑞康集团与我司合作时间',
      Oerlikon10:'超过10年',
      Oerlikon11:'，我们共同见证了彼此的发展与壮大。',
      Oerlikon12:'从国际顶级的纺织机制造商转型成为表面处理领域的世界领先公司，欧瑞康将大量相关的德国或PCT进中国的申请交由我司负责。无论是新申请翻译、审查、还是答辩、复审、流程管理，我司团队都能做到积极响应、及时处理，任何咨询都能快速回复，并以结果为导向，保障',
      Oerlikon13:'高授权率',
      Oerlikon14:'的同时',
      Oerlikon15:'争取客户需要的保护范围。',
      Oerlikon16:'由于欧瑞康新申请流程复杂且涉及多家欧洲事务所分别负责，因此我司曾多次发现欧瑞康所提供的申请文件、信息以及英德文本存在此存在细微偏差，通过我方多次专业提醒，不但避免了后续复杂工作，也通过至纤至悉的服务获得了欧洲同行的好评。',
    overText1:'社会荣誉及奖项',
    overText2:'2022年至今A级纳税人',
    overText3:'',
    overText31:'',
    overText32:'',
    overText33:'',
    overText34:'',
    overText35:'',
    overText4:'2022年至今A信用等级',
    overText5:'',
    overText51:'',
    overText52:'',
    overText53:'',
     overText54:'',
      overText55:'',
    overText6:'入选全国精准服务保障名单',
    companyLine: '北京之于行知识产权代理有限公司（11767）',
    firstBatch: '第一批',
    rankNote: '* 排名不分先后，中华全国专利代理师协会2025年7月17日公布',
     rankNote2: '',
      rankNote3: '',
        rankNote4: '',
          rankNote5: '',
            rankNote6: '',
              rankNote7: '',
                rankNote8: '',
    strengthTitle: '数据见证专业实力——之于行持续保持优异授权率',
    strengthDesc: '权威数据表明，之于行知识产权代理有限公司在多个年度及阶段性榜单中，均以较高的专利授权率位居行业前列，反映出公司长期以来在专利代理工作中的专业水准与稳定表现。',
    media2022Title: '媒体报道：2022年结案发明专利授权率TOP1000榜',
    media2023Title: '媒体报道：2023发明专利结案量授权率排行榜',
     media2025Title: '媒体报道：2025年结案发明专利授权率',
    table: {
      agency: '专利代理机构',
      grantRate: '授权率',
      ranking: '排名'
    },
    companyNameShort: '北京之于行知识产权代理有限公司',
    sourceQianzhi: '（数据来源：曳嵎专利）',
    sourcePatentTeahouse: '（数据来源：专利茶馆）',
    achievements: {
      y2021title:'',
      y2021: '2021年 中华全国专利代理师协会会员单位',
      y2022a: '2022年 中国首都版权协会会员单位',
      y2022b: '2022年 参加首都知识产权区分会组织受心助学公益活动',
      y2023a: '2023年 中华商标协会会员单位',
      y2023b: '2023年 中国城市科学研究会地下空间专业委员会副会长单位',
      y2024a: '2024年 发起成立北京围手术期医学学会科技创新与成果转化专委会',
      y2024b: '2024年 国际保护知识产权协会（AIPPI）会员',
      y2023ctitle:'',
      y2023c: '2023年被首都知识产权服务业协会评定为二星级知识产权服务机构',
      y2025a: '2025年入选全国第一批"专利代理机构精准服务保障名单"',
      y2025b: '截止2025年连续三年获评国家知识产权公共服务平台信用等级A',
      y2025c: '截止2025年，共计五名同事入选最高人民法院诉讼代理人名单',
      y2025d: '截止2025年，共计八名同事入选中华商标协会商标人才库，其中，两人评定为一级'
    },
    creativeHub: {
      title: '创意天地',
      subtitle: '精选行业创意与案例灵感，持续更新'
    },
    showcase: {
      title: '从创意构思到专利授权，我们为您的每一个想法保驾护航',
      subtitle: '专业团队将您的创新理念通过精准制图呈现，再经专业撰写与申请流程，最终转化为具有法律效力的专利证书'
    },
    anli101: '创意构思与分析',
    anli102: '深入了解您的创新思路，通过专业分析确定可专利性和保护策略，为您的创意提供最佳的知识产权保护方案。',
    anli201: '专业技术制图',
    anli202: '运用专业制图软件，精确绘制技术方案图纸，确保专利申请文件的技术描述清晰准确，符合审查要求。',
    anli301: '专利撰写与申请',
    anli302: '资深专利代理师撰写高质量专利申请文件，全程跟踪申请流程，确保您的专利权益得到最大化保护。',
    dialog201:'该高质量专利于2024年08月22日向国家知识产权局提交实用新型专利申请，2025年07月29日成功获得实用新型专利授权，授权公告号为CN223158456U。',
    dialog202:'之于行团队在交底评估阶段，仔细考量了该产品的应用场景及机械结构的合理性， ',
    dialog203:'通过虚拟三维模型装配验证以及模仿实际使用 ，发现并优化掉了结构之间相互穿模的构件，',
    dialog204:'并结合发明人团队的临床经验，',
    dialog205:'通过专业的技术词汇准确表述产品的技术特征',
    dialog206:'，将技术方案整合为高质量的专利申请文件。',
    dialog207:'',
    dialog208:'',
    dialog209:'',
    dialog210:'该案发明人团队长期深耕口腔外科领域，在口腔颌面手术具备极其丰富的临床经验，通过实践创新，提出手术工具改良方案，为口腔颌面手术提供极大便捷，基于上述创新点，发明人团队撰写了技术方案交底。',
    dialog211:'结构',
    dialog212:'无法实现其应当实现的功能；',
    dialog213:'机械结构的',
    dialog214:'配合度不高',
    dialog215:'，各个部件',
    dialog216:'相互妨碍；',
    dialog217:'说明书',
    dialog218:'附图缺失；',
    dialog219:'本领域技术人员',
    dialog220:'无法正常生产制造',
    dialog221:'产品；',
    dialog222:'',
    dialog223:'',
    dialog224:'',



   



    learnMore: '点击了解更多',
    proofreading: {
      title: '专业专利校对与翻译服务',
      desc: '凭借多年校企合作经验，我们不仅提供高质量的专利校对服务，更编著了国内首部系统性德汉专利翻译教材，为知识产权领域提供专业的翻译解决方案',
     desc2:'',
desc3:'',
desc4:'',
      sloganTitle: '懂语言，更懂专利',
      sloganDesc: '对于专利翻译，"一字千金"毫不夸张，专利翻译区别于常规本地化翻译，在用词、取舍、规避风险、前瞻性考量等方面尤为考究。为了保护您的技术，让您的利益最大化，您需要选择一家专利翻译背景深厚的专业公司——之于行。',
     sloganDesc1:'',
      bookTitle: '《德汉专利翻译教程》',
      bookDesc: '之于行携手四川外国语大学编写的"国内首部德汉专利翻译教材"已由同济大学出版社出版。其内容详细又实用，为以德语为工作外语的专利代理师人才培养奠定基础，也便于工作涉及欧洲案件审查的专利审查员自学相关翻译知识。',
     bookDesc1:'',
      tacTitle: '翻译团队荣誉——TAC认证',
      tacDesc: '中国翻译协会（Translators Association of China ，TAC），简称中国译协 ，成立于1982年，是由全国与翻译工作相关的机关、企业事业单位、社会团体及个人自愿结成的学术性、行业性非营利组织，是翻译领域唯一的全国性社会团体。',
      tacDesc1:'',
       tacDesc2:'',
        tacDesc3:'',
      card1: {
         title0: '懂语言',
        title: '',
          title1:'',
        title2:'',
        desc: '我们的译员均毕业于国内顶尖德语院校及德国本土知名高校，全员持有德语专业八级证书，不仅具备扎实深厚的德语语言功底，更积累了丰富的实战翻译经验，能精准应对各类专业翻译需求，兼具语言专业性与文化理解力。'
     ,desc1:'',
     desc2:'',
     desc3:'',
     desc4:'',
      },
      card2: {
         title0: '更懂专利',
        title: '',
          title1:'',
        title2:'',
        desc: '不会撰写专利的人做不好专利翻译。之于行在专利领域深耕多年，无论是国内专利还是国际申请，从撰写到答辩，从确权到维权，通晓各个环节和各国法律，从专业高度把控专利翻译的质量。'
      ,desc1:''
      }
    }
  },
  expertise: {
    pageTitle: '专业领域',
    intro1: '作为电气工程、信息技术、机械工程、工艺工程、物理学、化学、生物化学、生物技术及医疗器械等领域的专家，我们能够深入理解各类技术发明，并在知识产权保护的各个领域为您提供专业的咨询和代理服务。',
    intro2: '凭借多年的实践经验，我们在以下专业领域积累了广泛而扎实的知识：',
    serviceTitle: '技术与法律一站式服务',
    serviceText: '作为您的专利代理人，我们不仅拥有深厚的技术专长，还将技术知识与专利、实用新型、商标和外观设计等领域的法律专业知识相结合，为您提供"技术与法律一站式"服务。',
    areas: {
      communication: '通信技术与数据传输',
      fiberOptics: '光纤技术',
      electronicComponents: '电子元件',
      highCurrentSwitches: '高电流/高压开关',
      weighing: '称重技术',
      xray: 'X射线技术',
      conveying: '输送技术',
      metrology: '计量技术',
      inspection: '检测设备',
      automotive: '汽车工程',
      construction: '建筑机械',
      machineTools: '机床',
      storage: '存储与运输系统',
      coating: '涂层技术',
      structural: '结构与土木工程',
      alloys: '合金与机械轴承',
      welding: '焊接与连接技术',
      organicChemistry: '有机与无机化学',
      polymer: '聚合物化学',
      pharmaceutical: '药物组合物',
      biotech: '生物技术工艺',
      chromatography: '色谱技术',
      catalysts: '催化剂',
      oled: '有机发光二极管（OLED）',
      semiconductor: '半导体技术',
      medical: '医疗工程',
      gaming: '游戏模拟器',
      control: '控制工程',
      automation: '自动化技术',
      foodProduction: '食品工程生产线'
    }
  },
  contact: {
    pageTitle: '联系我们',
    sendMessage:'发送消息',
    name:'联系人姓名',
    nameRequired:'请输入联系人姓名',
    email:'电子邮件',
    emailRequired:'请输入电子邮件地址',
    emailInvalid:'请输入有效的电子邮件地址',
    company:'公司名称',
    phone:'电话号码',
    country:'国家/地区',
    subject:'主题',
    subjectRequired:'请输入主题',
    message:'您的信息',
    messageRequired:'请输入您的信息',
    submit:'提交',
    sendSuccess:'消息发送成功',
    sendError:'消息发送失败'
  },
  news: {
    pageTitle: '动态资讯',
    categories: {
      all: '全部',
      academic: '学术成果',
      industrial: '产业前瞻',
      company: '企业动态'
    },
    loading: '正在加载新闻...',
    noData: '暂无新闻数据',
    unknownCategory: '未知类别'
  },
  home: {
    slogan: '得之于心，践之于行。',
    companyIntro: {
      title: '公司介绍',
      p1: '北京之于行知识产权代理有限公司（机构代码：11767）是经中国国家知识产权局批准的具有专利和商标代理资格的知识产权代理机构。',
      p2: '公司拥有多名海归留学人员，以及中科院博士、北京大学、同济大学、重庆大学、北京外国语大学等国内高校优秀毕业生。',
      p3: '公司长期服务于中国、美国和欧洲一流企业，特别是向国际律师及专利事务所提供涉外知识产权服务。'
    },
    background: {
      title: '背景',
      prefix: '源自',
      cas: '中科院',
      suffix: '的高质量专利管理团队',
      nationalBadge: '国家级专家团队'
    },
    agency: {
      title: '机构代码',
      label: '机构代码：'
    },
    stats: {
      title: '数十人专利团队',
      line1_prefix: '专利工程师及涉外专利翻译工作经验',
        line0_suffix: '10年',
      line1_suffix: '以上',
      line2_prefix: '专利团队中',
      line2_suffix: '毕业生比例',
      line3_prefix: '德语人才超过',
      line31_prefix: '12人',
      line32_prefix: ''
    },
    honors: {
      title: '行业荣誉与专业资质',
      desc: '我们始终深耕知识产权与科技创新服务领域，积极加入国内外重要行业组织并担任要职，连续多年获得行业协会认可与资质评定。这些荣誉不仅体现了我们的专业实力与行业影响力，也彰显了我们在推动科技成果转化与知识产权保护方面的持续贡献。'
    },
    assoc: {
      title: '行业协会的认可与感谢',
      caption1: '中国电力技术市场协会',
      caption2: '首都知识产权服务业协会'
    },
    clients: {
      title: '服务期超过五年的高满意度客户',
      desc: '之于行多年来承接过国内外大量知名大学、研究院所、行业头部企业及著名医疗机构的专利申报咨询及代理项目，其中，首都医科大学宣武医院、清华大学、北京住总集团有限责任公司等知名单位长期与我公司进行合作，期间每年定期开展专项培训与讲座，并配备专人负责案件监控。',
      names: {
        0: '瑞士欧瑞康集团',
        1: '阿特拉斯·科普柯集团',
        2: '清华大学',
        3: '北京大学',
        4: '华中科技大学',
        5: '首都医科大学宣武医院',
        6: '中国计量科学研究院',
        7: '北京住总集团有限责任公司',
        8: '泸州老窖股份有限公司',
        9: '广东省岭南南丁格尔护理研究院'
      }
    }
  },
  practice: {
    banner: {
      title: '服务范围及专业领域',
      subtitle: '提供全方位知识产权解决方案，覆盖多个专业技术领域'
    },
    intro: {
      title: '服务内容介绍'
    },
    services: {
      trademark: {
        title: '商标',
        descriptions: [
          '商标的<span class="highlight">注册咨询</span>、商标查询',
          '商标的转让、许可、变更、续展等',
          '代理<span class="highlight">商标权诉讼</span>、权属纠纷相关业务',
          '担任商标法律顾问',
          '注册商标的跟踪监控'
        ]
      },
      litigation: {
        title: '诉讼',
        descriptions: [
          '代理专利的侵权纠纷、权属纠纷、合同争议或其他纠纷',
          '代理<span class="highlight">专利权无效</span>、<span class="highlight">复审</span>和行政诉讼程序',
          '代理知识产权侵权监测，进行侵权调查取证',
          '代理行政复议申请，代理侵权案件'
        ]
      },
      patents: {
        title: '专利',
        descriptions: [
          '优质专利申请的全程代理服务',
          '专利检索、专利申请权转让、专利的许可使用',
          '提供三性评价检索、专利分析和侵权检索及分析',
          '提供知识产权规划布局、专利地图导航服务',
          '专利预审、优先审查等专利申请加速服务'
        ]
      },
      ipLegal: {
        title: '知识产权、法律服务',
        descriptions: [
          '计算机软件著作权登记服务',
          '<span class="highlight">国外原产地名称、地理标志注册和登记服务</span>',
          '<span class="highlight">反不正当竞争及商业秘密保护服务</span>',
          '技术引进转让的知识产权法律服务',
          '工业设计专权',
          '<span class="highlight">Freedom To Operate</span>'
        ]
      },
      international: {
        title: '涉外专利',
        descriptions: [
          '<span class="highlight">PCT国际申请、巴黎公约</span>途径海外专利申请的全程代理服务',
          '海外专利检索及意见咨询',
          '专利文件翻译',
          '海外专利其他法律业务'
        ]
      },
      translation: {
        title: '翻译',
        descriptions: [
          '提供涉及知识产权、科技和法律等多语种对外专业翻译',
          '<span class="highlight">中英</span>科技文献互译',
          '<span class="highlight">中德</span>科技文献互译',
          '<span class="highlight">中日</span>科技文献互译'
        ]
      }
    },
    cases: {
      fast: {
        title: '以预审助力高效授权——“一种听力筛查装置”31天获权案例'
      },
      slow: {
        title: '历时2388天的坚持——“样本分析系统”发明专利成功授权'
      },
      labels: {
        preExam: '预审合格',
        sendStatus: '发文情况',
        firstPage: '授权公告文本首页',
        reexamWithdraw: '复审撤驳'
        ,
            reexamWithdraw0: '发文情况',
          reexamWithdraw2: '授权公告文本首页'
      }
    },
    learnMore: '点击了解更多',
    pharma: {
      title: '药品专利链接制度',
      description: '围绕药品专利链接制度核心业务，公司已形成服务国内外药企的成熟能力：既可为企业应对<span style="font-weight: bold !important;">药品专利纠纷提供专业的行政裁决案件处理支持</span>，也<span style="font-weight: bold !important;">能量身定制并落地知识产权管理体系</span>，有效帮助国内外药企化解专利风险、强化知识产权布局。'
    },
    textn1:'KES Pharma GmbH 凯思药业（德国）公司感谢函',
     textn2:'北京天衡药物研究院有限公司感谢函',
     textn3:'阿科尼生物系统公司委托之于行团队代理其发明专利“样本分析系统”。该案自进入中国国家知识产权局实质审查程序后，',
     textn4:'先后经历了四次审查意见通知书',
     textn5:'，审查员多次以创造性不足和权利要求书保护范围不清晰为由提出审查意见。',
     textn6:'面对持续的质疑，之于行团队',
     textn7:'在每一轮审查中均进行了细致的技术分析与创造性论证：',
     textn8:'在一、二通中，团队从现有技术差异点切入，逐条说明技术方案的创新点与实际应用价值；',
     textn9:'在三通意见中，针对权利要求7、9、12、16-20、23被指不符合《专利法》第26条第4款的情况，团队重新梳理说明书支持性，提交修改与说明； ',
     textn10:'在四通意见中，当全部权利要求1-25被认定不具备创造性时，团队仍坚持逐一反驳，结合实验数据与技术效果，强化本案的技术贡献；',
     textn11:'尽管在多轮审查意见答辩后仍被下达驳回决定，团队并未放弃，而是及时为申请人提出驳回复审请求。',
     textn12:'在复审过程中，团队集中展示了本案在结构创新和技术实现上的独特优势，最终于2018年3月12日成功撤销驳回决定。',
     textn13:'自提交至最终授权，本案历时2388天，期间历经多次答辩及复审程序，最终成功获权',
     textn14:' 。这一案例不仅彰显了之于行团队在专利创造性论证和复审策略上的深厚功力，更展现了我们在长期复杂案件中持续投入与坚守的专业精神。',
     dialoga1:'由中国人民解放军空军特色医学中心委托之于行团队代理的发明专利“一种听力筛查装置”，于2024年8月12日正式提交 至国家知识产权局。该申请在提交前，已由之于行团队精心筹备并',
     dialoga2:'成功通过中关村知识产权保护中心的严格预审',
     dialoga3:'，为快速授权奠定坚实基础。',
     dialoga4:'凭借高质量的申请文件与精准的专利布局，该案自正式提交后 ',
     dialoga5:'仅用时31天',
     dialoga6:' ，即于2024年9月12日获得授权，刷新了之于行团队在医疗器械领域',
     dialoga7:'通过预审通道实现最快授权的新纪录。',
     dialoga8:'此次高效授权，充分体现了之于行团队在高价值专利预审服务中的专业能力——从技术方案提炼、预审材料准备到全流程时间节点精准把控，团队始终以高标准确保申请质量，助力创新成果加速知识产权化。这不仅是对团队专业实力的有力印证，更是客户信赖与之于行高效服务深度融合的典范。',
    },
  lang: {
    chinese: '中文',
    english: 'English',
    german: 'Deutsch'
  }
}